import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL, INVENTORY_SERVICE_URL } from "../../utils/EmpUtil";
import { is401, is404 } from "../../errors/ErrorConstants";

class UploadDealerPriceClient {
  static baseUrl = BASE_URL;
  static invetoryPricingUrl = INVENTORY_SERVICE_URL;

  static getInventoryPricingData(user, path) {
    if (!user || !user.dealerId) {
      return Promise.reject(new Error("User data not available"));
    }

    let url;
    if (user.userType === "dealer") {
      url = `${this.invetoryPricingUrl}/dealer/${user.dealerId}/${path}`;
    }
    return axios.get(url, getHeaders());
  }

  static downloadInvPriceTemplate(user, colunmHeaders) {
    if (!user || !user.dealerGroup || user.dealerGroup.length === 0) {
      return Promise.reject(new Error("Dealer group data not available"));
    }

    function addAllDealerObjects(user) {
      const listOfDealers = [];
      let newDealerObj = {};

      user.dealerGroup.forEach((dealer) => {
        newDealerObj = {
          dealerId: dealer.completeDealerId,
          commonId: dealer.commonId,
        };
        listOfDealers.push(newDealerObj);
      });

      return listOfDealers;
    }

    const listOfDealers = addAllDealerObjects(user);
    const data = {
      columnHeaders: colunmHeaders,
      dealerInfos: listOfDealers,
    };
    const url = `${this.invetoryPricingUrl}/dealer/download-inventory-price-template`;

    return axios
      .post(url, data, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static retrieveDealerInventoryPrices(user) {
    if (
      !user ||
      !user.dealerId ||
      !user.dealerGroup ||
      user.dealerGroup.length === 0
    ) {
      return Promise.resolve({
        dealerPricesDataList: [
          {
            dealerInvPriceData: [],
          },
        ],
      });
    }

    return this.getInventoryPricingData(user, "inventory-prices-data")
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error) || is404(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static uploadDealerPrice(user, formData) {
    if (!user || !user.dealerId) {
      return Promise.reject(new Error("User data not available"));
    }

    const url = `${this.invetoryPricingUrl}/dealer/save-inventory-prices`;

    return axios
      .post(url, formData, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static persistAndPublishToIAL(user, requestBody) {
    if (!user || !user.dealerId) {
      return Promise.reject(new Error("User data not available"));
    }

    const url = `${this.invetoryPricingUrl}/dealer/update-inventory-prices`;

    return axios
      .put(url, requestBody, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static deleteInventoryPrices(vin, user) {
    if (!user || !user.dealerId) {
      return Promise.reject(new Error("User data not available"));
    }

    const url = `${this.invetoryPricingUrl}/dealer/delete-inventory-price?vin=${vin}&dealerId=${user.dealerId}`;
    return axios
      .delete(url, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default UploadDealerPriceClient;
